import React from "react"
import {useCatalog, useProgress, useRoomSetup, useSolution} from "../AppContext"
import {useCanvasCamera} from "../Hooks/CanvasCamera"
import {hasUrlFlag, URL_FLAG__NOCANVAS} from "../Helper/UrlFlag"
import {sceneItems} from "../Helper/CanvasHelper"
import {CanvasCamera} from "./Canvas/CanvasCamera"
import {Control} from "./Canvas/Control"
import ThreeCanvas from "../ThreeCanvas/ThreeCanvas"
import style from "./Canvas.css"

export const VIEW_2D = "2d"
export const VIEW_3D = "3d"
export const ITEM_DOOR = "door"
export const ITEM_WINDOW = "window"
export const ITEM_FURNITURE = "furniture"
export const ITEM_LAMP = "lamp"
export const ITEM_PRODUCT = "product"

export const Canvas = () => {
    const catalog = useCatalog()
    const progress = useProgress()
    const roomSetup = useRoomSetup()
    const canvasCamera = useCanvasCamera(roomSetup.getShape())
    const solution = useSolution()
    const show = !(hasUrlFlag(URL_FLAG__NOCANVAS) || progress.isRoom() || progress.isShape())
    const canvasView = progress.isSolution() ? VIEW_3D : VIEW_2D
    const products = progress.isSolution() ? sceneItems(solution.getItems(), catalog) : []

    const selectableTypes = () => {
        if (progress.isWall()) return [ITEM_DOOR, ITEM_WINDOW]
        if (progress.isFloor()) return [ITEM_FURNITURE]
        if (progress.isCeiling()) return [ITEM_LAMP]
        if (progress.isSolution()) return [ITEM_PRODUCT]
        return []
    }

    if (!show) return null

    return <>
        <div className={style.container} id={"canvas"}>
            <ThreeCanvas
                canvasView={canvasView}
                cameraIndex={canvasCamera.getCameraIndex()}
                setCameraIndex={canvasCamera.setCameraIndex}
                roomId={roomSetup.getId()}
                walls={roomSetup.getWalls()}
                selectableTypes={selectableTypes()}
                interiors={roomSetup.getInteriors()}
                setSelectedInteriorId={roomSetup.setHandle}
                setInteriorPosition={roomSetup.itemSetPosition}
                setInteriorSize={roomSetup.itemSetSize}
                products={products}
                productsVersion={solution.getVersion()}
                setSelectedProductId={solution.handlerSet}
                updateProducts={solution.updatePosition}
            />
        </div>
        <Control/>
        {progress.isSolution() && <CanvasCamera canvasCamera={canvasCamera}/>}
    </>
}